import * as Styled from './styles'

export interface SkeletonProps {
  type: 'title' | 'text' | 'image' | 'thumbnail'
}

export const Skeleton = ({ type }: SkeletonProps) => {
  return <Styled.Container type={type}></Styled.Container>
}
